var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-client-content" },
    [
      _vm.hasData
        ? [
            _vm.hasKeyDates
              ? _c(
                  "AIContentList",
                  {
                    staticClass: "ai-client-content__key-dates",
                    attrs: {
                      hasMargin: _vm.purchaseBehavior.total_purchase_amount > 0
                    }
                  },
                  [
                    _c(
                      "h4",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t.__(
                                "overview.tabs.TabSummary.clientContent.key_dates"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t.__(
                                "overview.tabs.TabSummary.clientContent.first_purchase",
                                {
                                  date: _vm.formattedFirstPurchaseDate
                                }
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t.__(
                                "overview.tabs.TabSummary.clientContent.last_purchase",
                                {
                                  date: _vm.formattedLastPurchaseDate
                                }
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.purchaseBehavior.total_purchase_amount > 0
              ? _c(
                  "p",
                  { staticClass: "ai-client-content__total-purchase-amount" },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t.__(
                                "overview.tabs.TabSummary.clientContent.total_amount"
                              )
                            ) +
                            " :\n            "
                        )
                      ]
                    ),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("numberformatCurrency")(
                            _vm.purchaseBehavior.total_purchase_amount
                          )
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ]
        : _c("NoInvoicingData")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }